// src/pages/Login.js
import React, { useState } from 'react';
import { adminLogin, getAdminAuthErrorMessage } from '../services/firebase';
import toast from 'react-hot-toast';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(email, password);
      toast.success('Welcome back, Admin!');
    } catch (err) {
      toast.error(getAdminAuthErrorMessage(err));
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      {/* Background grid */}
      <div style={{ position: 'fixed', inset: 0, backgroundImage: 'linear-gradient(rgba(0,230,118,0.03) 1px,transparent 1px),linear-gradient(90deg,rgba(0,230,118,0.03) 1px,transparent 1px)', backgroundSize: '48px 48px', pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 400, position: 'relative' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🏘️</div>
          <div style={{ fontFamily: 'Clash Display, sans-serif', fontSize: 28, fontWeight: 700, color: 'var(--green)' }}>
            MyTownly<span style={{ color: 'var(--orange)' }}>.</span>
          </div>
          <div style={{ fontSize: 12, color: 'var(--gray2)', fontFamily: 'JetBrains Mono', letterSpacing: 3, marginTop: 4 }}>ADMIN CONSOLE</div>
        </div>

        {/* Login card */}
        <div style={{ background: 'var(--card)', border: '1px solid var(--border2)', borderRadius: 16, padding: 28 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, fontFamily: 'Clash Display, sans-serif' }}>Sign in to continue</div>

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label className="form-label">EMAIL</label>
              <input type="email" placeholder="admin@mytownly.in" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label className="form-label">PASSWORD</label>
              <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-green" style={{ width: '100%', padding: 11, marginTop: 4, fontSize: 14 }} disabled={loading}>
              {loading ? <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}><span className="spinner" style={{ width: 16, height: 16 }} /> Signing in...</span> : 'Sign In →'}
            </button>
          </form>

          <div style={{ marginTop: 16, padding: 12, background: 'var(--green-dim)', borderRadius: 8, border: '1px solid var(--green-mid)', fontSize: 12, color: 'var(--green)', fontFamily: 'JetBrains Mono' }}>
            ℹ First time? Create an admin account in Firebase Auth console, then login here.
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 11, color: 'var(--gray)', fontFamily: 'JetBrains Mono' }}>
          MYTOWNLY ADMIN v1.0 • PILER, AP
        </div>
      </div>
    </div>
  );
}
